//creates reusable components

export const homeObjOne = {
    id:'about',
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    topLine: 'Online Banking',
    headLine: 'Your 24 hours bank',
    description: 'Do all your day-to-day banking activities online, 24 hours per day, 365 days a year. RJS Bank 365 online puts you in control. Carry out a wide range of banking activities, apply for products and manage your accounts with 365 online and phone, our mobile banking app and our tablet banking app.',
    buttonLabel: 'Get started',
    imgStart: false,
    img: require('../images/svg4.svg').default,
    alt: 'Error 404',
    dark:false,
    primary: false,
    darkText: true,
}
export const homeObjTwo = {
    id:'discover',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: 'Premium bank',
    headLine: 'Online and mobile banking.',
    description: 'Access your accounts anytime, anywhere. Fast and secure access to your account. Pay bills at a time convenient to you, and transfer funds to different accounts',
    buttonLabel: 'Learn more',
    imgStart: true,
    img: require('../images/svg7.svg').default,
    alt: 'Error 404',
    dark: true,
    primary: true,
    darkText: false,
}


export const homeObjThree = {
    id:'services',
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    topLine: 'Premium bank',
    headLine: 'Unlimited Transaction with zero fees',
    description: 'Whether you’re opening your first bank account or switching from another financial institution, we’re here to help. With our mobile app, mobile payments and the support of our advisers, you can take control of your financial wellbeing. ',
    buttonLabel: 'Learn more',
    imgStart: false,
    img: require('../images/svg2.svg').default,
    alt: 'Error 404',
    dark:false,
    primary: false,
    darkText: true
}

export const homeObjFour = {
    id:'signup',
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    topLine: 'Sign Up',
    headLine: 'Create your account today',
    description: 'Getting started with 365 online banking. Available to both personal and business customers.You can manage your daily finances no matter where you are in the world. Access to your funds in-branch, online or on the web app.  ',
    buttonLabel: 'Start now',
    imgStart: true,
    img: require('../images/svg8.svg').default,
    alt: 'Error 404',
    dark: false,
    primary: false,
    darkText: true,
}